var React = require('react');

function ExclamationCircle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"currentColor","key":0}),React.createElement("path",{"fill":"#fff","d":"M14.53 22.835h3.836v3.164H14.53v-3.164ZM14.53 7h3.836v13H14.53V7Z","key":1})]);
}

ExclamationCircle.defaultProps = {"fill":"none","viewBox":"0 0 32 32"};

module.exports = ExclamationCircle;

ExclamationCircle.default = ExclamationCircle;
